import React from 'react'


   
export const BANNUSERREQUEST = "BANNUSERREQUEST"
export const BANNUSERSUCCESS = "BANNUSERSUCCESS"
export const DBANNUSERFAILURE = "DBANNUSERFAILURE"


export const REMOVEBANNREQUEST = "REMOVEBANNREQUEST"
export const REMOVEBANNSUCCESS = "REMOVEBANNSUCCESS"
export const REMOVEBANNFAILURE = "REMOVEBANNFAILURE"

export const ADDBANNREQUEST = "ADDBANNREQUEST"
export const ADDBANNSUCCESS = "ADDBANNSUCCESS"
export const ADDBANNFAILURE = "ADDBANNFAILURE"



